import React from "react";
import useTranslation from "../../hooks/useTranslation";

export default function TabBar({ activePage, setActivePage }) {
  const { t } = useTranslation();
  return (
    <div className="tabs-bar">
      <div className="tabs-container">
        <button type="button" className={`tab ${activePage === 'dashboard' ? 'active' : ''}`} onClick={() => setActivePage('dashboard')}>{t('Dashboard')}</button>
        <button type="button" className={`tab ${activePage === 'doctors' ? 'active' : ''}`} onClick={() => setActivePage('doctors')}>{t('Doctors')}</button>
        <button type="button" className={`tab ${activePage === 'patients' ? 'active' : ''}`} onClick={() => setActivePage('patients')}>{t('Patients')}</button>
      </div>
    </div>
  );
}
